import * as moment from 'moment';

const DAY_NAME_TO_INDEX: Record<string, number> = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export function buildRecurringWeekDates(
  openWindow: string | Date | moment.Moment | null | undefined,
  closeWindow: string | Date | moment.Moment | null | undefined,
  recurringDays: string[] | null | undefined
): Array<Record<string, string[]>> {
  if (!Array.isArray(recurringDays) || recurringDays.length === 0) {
    return [];
  }

  const openWindowMoment = moment(openWindow).utcOffset(0, true);
  const closeWindowMoment = moment(closeWindow).utcOffset(0, true);

  if (
    !openWindowMoment.isValid() ||
    !closeWindowMoment.isValid() ||
    openWindowMoment.isAfter(closeWindowMoment)
  ) {
    return [];
  }

  const selectedDayIndexes = new Set(
    recurringDays
      .map((dayName) => DAY_NAME_TO_INDEX[dayName.toLowerCase()])
      .filter((dayIndex): dayIndex is number => dayIndex !== undefined)
  );

  if (selectedDayIndexes.size === 0) {
    return [];
  }

  const startDate = openWindowMoment.clone().startOf('day');
  const endDate = closeWindowMoment.clone().startOf('day');
  const weekDates: Array<Record<string, string[]>> = [];
  let weekStart = startDate.clone().subtract(startDate.day(), 'days');
  let weekNumber = 1;

  while (weekStart.isSameOrBefore(endDate, 'day')) {
    const weekEnd = weekStart.clone().add(6, 'days');
    const effectiveStart = weekStart.isBefore(startDate, 'day')
      ? startDate.clone()
      : weekStart.clone();
    const effectiveEnd = weekEnd.isAfter(endDate, 'day')
      ? endDate.clone()
      : weekEnd.clone();
    const matchedDates: string[] = [];
    const currentDate = effectiveStart.clone();

    while (currentDate.isSameOrBefore(effectiveEnd, 'day')) {
      if (selectedDayIndexes.has(currentDate.day())) {
        matchedDates.push(
          currentDate
            .clone()
            .hour(openWindowMoment.hour())
            .minute(openWindowMoment.minute())
            .second(openWindowMoment.second())
            .millisecond(openWindowMoment.millisecond())
            .utcOffset(0, true)
            .format()
        );
      }
      currentDate.add(1, 'day');
    }

    if (matchedDates.length > 0) {
      weekDates.push({ [`Week${weekNumber}`]: matchedDates });
    }

    weekStart.add(7, 'days');
    weekNumber += 1;
  }

  return weekDates;
}